import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// nm2024 themed components
import { LinkNm2024  } from '../../../../nm2024Theme/components/link/styles';
import { SectionContainerNm2024  } from '../../../../nm2024Theme/components/sectionContainer/styles';
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';

export default () => {
  return (
    <SectionContainerNm2024
      id='home-advisor-connect-generic'
      backgroundVariant='darkDefault'
      themeType='darkTheme'>
      <Row align='center'>
        <Col
          medium={8}
          align='center'>
          <TypographyNm2024
            component='h2'
            themeType='darkTheme'
            nextElement='typography'
            weight={600}>
            Ready to feel better about <WidowBlock>your money&#63;</WidowBlock>
          </TypographyNm2024>
          <TypographyNm2024
            themeType='darkTheme'
            nextElement='button'>
            It&#39;s easy to get started&#8212;no commitment, just a better conversation.
          </TypographyNm2024>
          <LinkNm2024
            variant='buttonLinkPrimary'
            themeType='darkTheme'
            linkUrl='/find-a-financial-advisor/'>
            Find a financial advisor
          </LinkNm2024>
        </Col>
      </Row>
    </SectionContainerNm2024>
  );
};
